import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';
import {
  Primary45Base,
  Neutral95,
  Primary20,
  Primary90,
  Neutral90,
  Neutral99,
  Neutral70,
  Primary95,
} from '@emisgroup/design-tokens/build/ts/variables';

const emis = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: Primary45Base,
        dark: Primary20,
        light: Primary90,

      },
      background: {
        default: Neutral99,
        paper: Neutral99,
      },
      navigation: {
        background: Primary20,
        indicator: Neutral99,
        color: Neutral95,
        selectedColor: Neutral99,
      },
    },
    pageTheme: {
      home: genPageTheme({ colors: [Primary45Base, Primary20], shape: shapes.wave }),
    },
    fontFamily: 'Roboto, Arial, sans-serif',
    defaultPageTheme: 'home',
  }),
  components: {
    BackstageHeader: {
      styleOverrides: {
        header: ({ theme }) => ({
          backgroundImage: 'unset',
          backgroundColor: theme.palette.primary.dark,
        }),
        title: ({ theme }) => ({
          color: theme.page.fontColor,
          fontWeight: 900,
        }),
        subtitle: () => ({
          color: Neutral95,
        }),
        type: () => ({
          color: Neutral95
        })
      }
    },
    BackstageOpenedDropdown: {
      styleOverrides: {}
    },
    BackstageTable: {
      styleOverrides: {
        root: {
          '& th': {
            backgroundColor: Neutral90,
          },
          '& tr:nth-child(odd)': {
            backgroundColor: Neutral99,
          }
        },
      },
    },
    BackstageSelectInputBase: {
      styleOverrides: {
        input: {
          '&:focus': {
            background: Primary95,
          },
        }
      }
    },
    BackstageSidebar: {
      styleOverrides: {

      }
    },
    CatalogReactEntityAutocompletePickerClassKey: {
      styleOverrides: {
        root: {

        }
      }
    },
    CatalogReactUserListPicker: {
      styleOverrides: {
        root: () => ({
          '&': {
            'background-color': Neutral90
          }
        })
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '&[aria-expanded=true]': {
            backgroundColor: Primary95,
            color: Neutral99,
          },
          '&[aria-expanded=true] path': {
            fill: Neutral99,
          },
        },
        option: {
          ' &[aria-selected=true], &[aria-selected=true]:hover': {
            'background-color': Primary95
          },
          '&:hover': {
            'background-color': Primary95
          }
        },
        focused: () => ({
          '&': {
            'background-color': Primary95,
          }
        })
      },
    },
    MuiChip: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: '1.5rem',
          backgroundColor: theme.palette.primary.main,
          color: Neutral99,
          margin: 4,
        }),
        outlined: ({ theme }) => ({
          borderColor: theme.palette.primary.main,
          color: theme.palette.primary.main,
        })
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: () => ({
          '&.Mui-selected, &.Mui-selected:hover': {
            'background-color': Primary95,
            'color': Neutral70
          },
          '&:hover': {
            'background-color': Primary95
          }
        })
      }
    }
  }
});

export default emis;
